import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./css/Header.css";
import SideMenu from "./SideMenu";
import { useDispatch, useSelector } from "react-redux";
// import "tippy.js/dist/tippy.css";
// import "tippy.js/themes/light.css";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LogoutIcon from "@mui/icons-material/Logout";
import MobileHeader from "./MobileHeader";
import logo from "../../img/logo.png";
import getUserData, { clearUserDataCache } from "../../utils/userDataService.js";
import { userNotExist } from "../../redux/features/userSlice.js";
import AddMoneyModal from "../Modal/AddMoneyModal";
import NotLoginPopupModal from "../Modal/NotLoginPopupModal";

const Header = () => {
	const { user } = useSelector((state) => state.user);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [sideMenu, setSideMenu] = useState(false);
	const [balance, setBalance] = useState("");
	const [showAddMoneyModal, setShowAddMoneyModal] = useState(false);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		// Only fetch balance if user exists, avoid duplicate API calls
		if (user && user.walletBalance !== undefined) {
			setBalance(user.walletBalance);
		} else if (user) {
			getUserData(null, null, setBalance);
		}
	}, [user]);

	return (
		<>
			<div className="header-container w-100">
				<header className="header d-none d-md-block d-lg-block container w-100">
					<div className="header-main">
						<div
							className="burger-icon d-none d-lg-none"
							onClick={() => setSideMenu(!sideMenu)}
						>
							<MenuIcon className="icon" />
						</div>
						<SideMenu sideMenu={sideMenu} setSideMenu={setSideMenu} />
						<div className="logo gap-2" onClick={() => navigate("/")}>
							<img
								className="rounded-4"
								width={48}
								src={logo}
								alt="logo"
								loading="lazy"
							/>
							<span>Coinsup</span>
						</div>
						<div className="action-btns gap-3">
							<div className="menus d-none d-md-none d-lg-block">
								<ul className="p-0">
									<li>
										<Link to="/support">Contact Us</Link>
									</li>
									{!user && (
										<li>
											<Link to="/login">My Account</Link>
										</li>
									)}
									{user && (
										<li>
											<Link to="/user-dashboard">Dashboard</Link>
										</li>
									)}
									<li>
										<Link to="/announcement">Announcement</Link>
									</li>
									<li>
										<Link to="/leaderboard">Leaderboard</Link>
									</li>
									<li>
										<Link to="/wallet">Wallet</Link>
									</li>
								</ul>
							</div>
							{user && (
								<div className="d-flex align-items-center gap-2">
									<div
										onClick={() => !user ? setShowModal(true) : setShowAddMoneyModal(true)}
										className="p-1 pointer border shadow-sm px-3 rounded-pill text-dark bg-white d-flex justify-content-between align-items-center"
									>
										<span>{parseFloat(balance).toFixed(2)}</span>
										<span className="ms-2">
											<AccountBalanceWalletIcon className="" />
										</span>
									</div>
								</div>
							)}

							<span className="menu-img-container d-flex">
								{user ? (
									<>
										<div
											onClick={() => {
												localStorage.removeItem("token");
												clearUserDataCache();
												dispatch(userNotExist());
											}}
											className="p-1 pointer shadow-sm px-2 rounded-pill text-dark bg-warning d-flex jsutify-content-between align-items-center"
										>
											<PersonIcon className="" />
											<LogoutIcon className="d-lg-block d-md-none d-none text-dark" />
										</div>
									</>
								) : (
									<div
										className="p-1 sing-up pointer bg-warning shadow-sm px-3 rounded-pill text-dark fw-bold d-flex jsutify-content-between align-items-center"
										onClick={() => navigate("/login")}
									>
										<span>Login</span>
									</div>
								)}
							</span>
						</div>
					</div>
				</header>
			</div>

			<MobileHeader />
			
			<AddMoneyModal
				showAddMoneyModal={showAddMoneyModal}
				setShowAddMoneyModal={setShowAddMoneyModal}
			/>
			<NotLoginPopupModal
				string="Please login to add money to your wallet."
				show={showModal}
				onClose={() => setShowModal(false)}
			/>
		</>
	);
};

export default Header;
